<section class="app-end h-100 pb-lg-4 pb-4">
  <div
    class="app-end__con"
    [appAnimate]="'fadeIn'"
    [speed]="'fast'"
    [aos]="0.2"
    [once]="true"
  >
    <picture>
      <source
        media="(max-width:768px)"
        srcset="assets/images/end-page/end-background-mob.png"
      />
      <img
        ngSrc="assets/images/end-page/end-background.png"
        alt="logo foxy"
        width="2733"
        height="1537"
        priority="true"
        class="app-end__con--background"
      />
    </picture>

    <div class="app-end__con__wr">
      <div class="app-end__con__wr__center">
        <p class="app-end__con__wr__center--thank">
          Dziękujemy <br />
          za udział w Loterii Foxy!
        </p>
        <h2 class="app-end__con__wr__center--h2">...i kasa w mig</h2>
        <p class="app-end__con__wr__center--p">
          Rejestracja zakończyła się 15.11.2025 roku.
        </p>
        <button
          type="button"
          (click)="navigationClick.emit(SectionType.WINNERS_LIST)"
          class="app-btn app-btn--blue app-end__con__wr__center--a"
        >
          WYNIKI DOSTĘPNE TUTAJ
        </button>
        <p class="app-end__con__wr__center--p">
          Gratulujemy wszystkim Zwycięzcom!
        </p>
      </div>
    </div>
  </div>
</section>
